import { allStates } from 'features/recovery-dashboard/common/constants/forms';

export const marketCategories = [
    { value: 'city', label: 'City' },
    { value: 'town', label: 'Town' },
    { value: 'village', label: 'Village' },
    { value: 'submarket', label: 'Submarket' },
    { value: 'office', label: 'Office' },
    { value: 'retail', label: 'Retail' },
    { value: 'residential', label: 'Residential' },
    { value: 'industrial', label: 'Industrial' },
    { value: 'business_improvement_district', label: 'Business Improvement District' },
    { value: 'downtown', label: 'Downtown' },
    { value: 'district', label: 'District' },
    { value: 'neighborhood', label: 'Neighborhood' },
    { value: 'market', label: 'Market' },
];

export const coveredMarketCategories: { [key: string]: string } = {
    city: 'Cities',
    town: 'Towns',
    village: 'Villages',
    submarket: 'Submarkets',
    district: 'Districts',
    neighborhood: 'Neighborhoods',
    market: 'Markets',
};

export const statesItems = allStates.map((state) => ({ value: state, label: state }));
